module.exports = __webpack_public_path__ + "img/greeting.49c86686.svg";